import { DataTablesRecipient } from "@components/general/DataTablesRecipient/DataTablesRecipient";
import { faArrowLeft, faChartBar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getLeccionesVistas } from "@helpers/httpRequests/httpRequestLeccionesVistas/httpRequestsLeccionesVistas";
import { getLeccionesByCodigoCurso } from "@helpers/httpRequests/httpRequestsLecciones/httpRequestsLecciones";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Checkbox } from "primereact/checkbox";
import { getCursos } from "@helpers/httpRequests/httpRequestsCursos/httpRequestsCursos";
import UserContext from "@context/User/UserContext";
import { useTranslation } from "react-i18next";
import getDateFromUnix from "@helpers/dates/getDateFromUnix/getDateFromUnix";

const ListarAvanceEmpleado = ({
	idPerfilEmpleado,
	setMostrarGraficaEmpleado,
	nombreEmpleadoSeleccionado,
	indexAvance,
	tiempoEnPlataformaEmpleado,
	mostrarGraficaEmpleado,
	diasPlataformaEmpleado,
	minutosPlataformaEmpleado,
	mesesPlataformaEmpleado,
	yearsPlataformaEmpleado,
	horasPlataformaEmpleado,
	setMostrarGraficaInvitado,
}) => {

	const {t} = useTranslation();

	const { contextValue, setContextValue } = useContext(UserContext);

	const { usuarioLogeado } = contextValue;

	const { modoOscuro } = usuarioLogeado;

	const [mostrarLeccionesEmpleado, setMostrarLeccionesEmpleado] = useState(false);

	const [leccionesTomadas, setLeccionesTomadas] = useState(0);

	const [leccionesTotales, setLeccionesTotales] = useState(0);

	const [leccionesVistasEmpleado, setLeccionesVistasEmpleado] = useState([]);

	const [leccionesSeleccionadasEmpleado, setLeccionesSeleccionadasEmpleado] = useState([]);

	const [dataTableColumns, setDataTableColumns] = useState([]);

	const [leccionesListadasEmpleado, setLeccionesListadasEmpleado] = useState(false);

	const [cursos, setCursos] = useState([]);

	const [avancePorCursoEmpleado, setAvancePorCursoEmpleado] = useState([]);

	const [codigoCurso, setCodigoCurso] = useState(null);

	const [tiempoPlataforma, setTiempoPlataforma] = useState(null);

	const handleClickEmpleado = async (data) => {
		try {
			//*Esta funcion se encargara de listar las lecciones del curso que se seleccione.
			const { codigoCurso, name, cursos, lecciones } = data;
			setCodigoCurso(codigoCurso);

			// console.log(lecciones);
			// console.log(codigoCurso);

			setLeccionesTomadas(lecciones);

			const { data: datosLeccion } = await getLeccionesByCodigoCurso(codigoCurso);

			setLeccionesTotales(datosLeccion.length);

			if (datosLeccion.length > 0) {
				setLeccionesSeleccionadasEmpleado(datosLeccion);
				setMostrarLeccionesEmpleado(true);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const obtenerFecha = (boolean, codigoLeccion) => {
		if (boolean) {
			let data = leccionesVistasEmpleado.find((leccionVista) => leccionVista.codigoLeccion === codigoLeccion);
			// return getFechaSinHora(data.fecha);
			return getDateFromUnix(data.fecha);	
		} else {
			return " - ";
		}
	};

	const handleOcultarGraficas = () => {
		setMostrarGraficaEmpleado(false);
		setMostrarGraficaInvitado(false);
	};

	useEffect(() => {
		const obtenerCursos = async () => {
			try {
				const { data: cursos } = await getCursos();
				// console.log(cursos);
				setCursos(cursos);
			} catch (error) {
				console.log(error);
			}
		};

		obtenerCursos();

		const obtenerHistorial = async () => {
			try {
				const { data } = await getLeccionesVistas(idPerfilEmpleado);
				if (Array.isArray(data)) {
					setLeccionesVistasEmpleado(data);
				} else {
					setLeccionesVistasEmpleado([data]);
				}
				setLeccionesListadasEmpleado(true);
			} catch (error) {
				console.log(error);
			}
		};

		obtenerHistorial();

		if (codigoCurso !== null) {
			//*Se asigna la tabla para ver los avances de cada empleado (Grafica)
			setDataTableColumns([
				{
					name: t('lesson'),
					selector: (row) => row.nombre,
					sortable: true,
					center: true,
					width: "50%",
				},
				{
					name: t("userProgress.completedOn"),
					cell: (row) => (
						<>
							<div className="text-center">
								<p>
									{" "}
									{obtenerFecha(
										leccionesVistasEmpleado.some((leccionVista) => leccionVista.codigoLeccion === (leccionVista.codigoCurso.startsWith("ING") ? row.claseLeccion : row.codigoLeccion)) ? true : false,
										codigoCurso.startsWith("ING") ? row.claseLeccion : row.codigoLeccion
									)}{" "}
								</p>
							</div>
						</>
					),
					center: true,
					ignoreRowClick: true,
					allowOverflow: true,
					width: "25%",
				},
				{
					name: t('userProgress.completed'),
					cell: (row) => (
						<>
							{/* <Checkbox className="mx-3" checked={leccionesVistasEmpleado.some((leccionVista) => leccionVista.codigoLeccion === row.codigoLeccion)}></Checkbox> */}
							<Form.Check type="checkbox" checked={leccionesVistasEmpleado.some((leccionVista) => leccionVista.codigoLeccion === row.codigoLeccion)}/>
						</>
					),
					center: true,
					ignoreRowClick: true,
					allowOverflow: true,
					width: "25%",
				},
			]);
		}
	}, []);

	useEffect(() => {
		const listarAvancePorCursoEmpleado = async () => {
			try {
				// console.log("Longitud de lecciones vistasEmpleado");
				// console.log(leccionesVistasEmpleado);

				const { data } = await getLeccionesVistas(idPerfilEmpleado);

				if (Array.isArray(data)) {
					setLeccionesVistasEmpleado(data);
				} else {
					setLeccionesVistasEmpleado([data]);
				}
			} catch (error) {
				console.log(error);
				setLeccionesVistasEmpleado([]);
			}
		};

		listarAvancePorCursoEmpleado();
		if (codigoCurso !== null) {
			//*Se asigna la tabla para ver los avances de cada empleado (Grafica)
			setDataTableColumns([
				{
					name: t('lesson'),
					selector: (row) => row.nombre,
					sortable: true,
					center: true,
					width: "50%",
				},
				{
					name: t("userProgress.completedOn"),
					cell: (row) => (
						<>
							<div className="text-center">
								<p>
									{" "}
									{obtenerFecha(
										leccionesVistasEmpleado.some((leccionVista) => leccionVista.codigoLeccion === (leccionVista.codigoCurso.startsWith("ING") ? row.claseLeccion : row.codigoLeccion)) ? true : false,
										codigoCurso.startsWith("ING") ? row.claseLeccion : row.codigoLeccion
									)}{" "}
								</p>
							</div>
						</>
					),
					center: true,
					ignoreRowClick: true,
					allowOverflow: true,
					width: "25%",
				},
				{
					name: t('userProgress.completed'),
					cell: (row) => (
						<>
							{/* <Checkbox
								className="mx-3"
								checked={leccionesVistasEmpleado.some(
									(leccionVista) => leccionVista.codigoLeccion === (leccionVista.codigoLeccion.startsWith("ING") ? row.claseLeccion : row.codigoLeccion)
								)}></Checkbox> */}

								<Form.Check type="checkbox" checked={leccionesVistasEmpleado.some(
									(leccionVista) => leccionVista.codigoLeccion === (leccionVista.codigoLeccion.startsWith("ING") ? row.claseLeccion : row.codigoLeccion)
								)}/>
						</>
					),
					center: true,
					ignoreRowClick: true,
					allowOverflow: true,
					width: "25%",
				},
			]);
		}
	}, [leccionesSeleccionadasEmpleado || idPerfilEmpleado || codigoCurso]);

	useEffect(() => {
		const listarLeccionesVistas = async () => {
			try {
				let arregloCursos = [];

				if (leccionesVistasEmpleado.length > 0) {
					// console.log("La longitud es mas de 0");
					const { data: cursos } = await getCursos();
					cursos.map((curso, idx) => {
						let cantidadLecciones = leccionesVistasEmpleado.filter((dato) => dato.codigoCurso.startsWith(curso.codigoCurso));
						arregloCursos.push({
							name: t(curso.nombre),
							codigoCurso: curso.codigoCurso,
							[t("lessons")]: cantidadLecciones.length,
						});
					});

					// console.log("arregloCursos");
					// console.log(arregloCursos);

					setAvancePorCursoEmpleado(arregloCursos);
				} else {
					// console.log("La longitud es 0");

					arregloCursos.push({
						name: "",
						codigoCurso: "",
						[t("lessons")]: 0,
					});
					setAvancePorCursoEmpleado(arregloCursos);
				}
			} catch (error) {
				console.log(error);
			}
		};

		listarLeccionesVistas();
	}, [leccionesVistasEmpleado]);

	return (
		<Row>
			{mostrarLeccionesEmpleado ? (
				<>
					<Col className="col-12 mt-4">
						<Row className="justify-content-end">
							<Col>
								<h6>
									<FontAwesomeIcon icon={faChartBar} /> {t('userProgress.progressByLessonBusiness')}
								</h6>
							</Col>
							<Col className="col-auto pointer" onClick={handleOcultarGraficas}>
								<FontAwesomeIcon icon={faArrowLeft} /> {t('back')}
							</Col>
						</Row>
					</Col>
					<Col className="mt-5">
						<>
							<p>
								<b>{t('lessons')}: {leccionesTotales} </b>
							</p>
							<p>
								<b>{t('userProgress.progressByLessonBusiness')}: {leccionesTomadas}</b>
							</p>
						</>
					</Col>
					<Col className="col-12 mb-5">
						{/* //*Aqui se listaran las lecciones del curso que se haya seleccionado */}
						<DataTablesRecipient columns={dataTableColumns} data={leccionesSeleccionadasEmpleado} />
					</Col>
				</>
			) : (
				<>
					<Col className="col-12 mt-4">
						<Row className="justify-content-end">
							<Col>
								<h6>
									<FontAwesomeIcon icon={faChartBar} /> {t('userProgress.progressByCourse')}
								</h6>
							</Col>
							<Col className="col-auto pointer" onClick={handleOcultarGraficas}>
								<FontAwesomeIcon icon={faArrowLeft} /> {t('back')}
							</Col>
						</Row>
					</Col>
					<Col className="mt-5">
						<Row>
							<Col>
								<p>
									<b>{t('studentsName')}: </b>
									{nombreEmpleadoSeleccionado}
								</p>

								{minutosPlataformaEmpleado === 0 ? (
									<p>{t('userProgress.noTimeOnPlatform')}</p>
								): (
									<p>
										{t('userProgress.timeOnPlatform')}: {yearsPlataformaEmpleado > 0 && `${yearsPlataformaEmpleado} ${yearsPlataformaEmpleado === 1 ? t('year') : t('years')}`}{" "}
										{mesesPlataformaEmpleado > 0 && `${mesesPlataformaEmpleado} ${mesesPlataformaEmpleado === 1 ? t('month') : t('months')}`}{" "}
										{diasPlataformaEmpleado > 0 && `${diasPlataformaEmpleado} ${diasPlataformaEmpleado === 1 ? t('day') : t('days')}`}{" "}
										{horasPlataformaEmpleado > 0 && `${horasPlataformaEmpleado} ${horasPlataformaEmpleado === 1 ? t('hour') : t('hours')}`}{" "}
										{minutosPlataformaEmpleado > 0 && `${minutosPlataformaEmpleado} ${minutosPlataformaEmpleado === 1 ? t('minute') : t('minutes')}`}
									</p>
								)}
							</Col>
						</Row>
						<ResponsiveContainer width="100%" height={400}>
							<BarChart data={avancePorCursoEmpleado}>
								<XAxis dataKey="name" angle={-45} tick={false} interval={0} />
								<YAxis />
								<CartesianGrid strokeDasharray="3 3" />
								<Tooltip
									itemStyle={{
										color: "#000",
									}}
									labelStyle={{
										color: "#000",
									}}
								/>
								<Legend
									wrapperStyle={{
										color: "#000",
									}}
								/>
								<Bar
									className="pointer"
									onClick={handleClickEmpleado}
									dataKey={t('lessons')}
									fill="#F59E0B"
								/>
							</BarChart>
						</ResponsiveContainer>
					</Col>
				</>
			)}
		</Row>
	);
};

export default ListarAvanceEmpleado;
